export default __webpack_public_path__ + "static/media/materiaprima-01.09db4cfa.jpg";